package com.eladfinish.bible.contest.screens.browse.tableOfContents.model

enum class CompleteType {
    PARTIALLY_EXPOSURE, // missing words (2 on each verse, or custom number from pre-define completion)
    REYSHOT_EXPOSURE,
    SEYFOT_EXPOSURE,
    SHUFFLE_VERSES,
    CREATE_COMPLETIONS,
    NEXT_EXPOSURE_VERSE,
    NEXT_EXPOSURE_HALF,
    NEXT_EXPOSURE_WORD,
    LEXICOGRAPHICALLY_SORTING,
    RESET,
}
